function removeDomElement(selector: string) {
  const element = document.querySelector(selector) as HTMLElement;
  if (element) element.remove();
}
export default function removeMeta() {
  removeDomElement('title');
  removeDomElement('meta[name="description"]');
  removeDomElement('meta[name="keywords"]');
  removeDomElement('meta[property="og:type"]');
  removeDomElement('meta[property="og:title"]');
  removeDomElement('meta[name="twitter:title"]');
  removeDomElement('meta[property="og:description"]');
  removeDomElement('meta[name="twitter:description"]');
  removeDomElement('meta[property="og:image"]');
  removeDomElement('meta[property="og:image:secure_url"]');
  removeDomElement('meta[name="twitter:image"]');
  removeDomElement('meta[property="og:image:width"]');
  removeDomElement('meta[property="og:image:height"]');
  removeDomElement('meta[property="og:url"]');
  removeDomElement('meta[name="twitter:url"]');
}
